import request from '@/axios/warehouseClerk'

// 08-获取物流单列表
export function getLogisticsList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsList',
    method: 'post',
    data
  })
}
// 05-更新物流单物流信息
export function updateLogisticsInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/updateLogisticsInfo',
    method: 'post',
    data
  })
}
// 04-获取物流单物流历史记录
export function getLogisticsLogList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsLogList',
    method: 'post',
    data
  })
}
// 07-获取物流单图片类型和示例
export function getLogisticsImageType(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsImageType',
    method: 'post',
    data
  })
}
// 06-物流单到货
export function arriveLogisticsInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/arriveLogisticsInfo',
    method: 'post',
    data
  })
}
// 8-出库单列表
export function getOutboundOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/warehouse/Warehouse/getOutboundOrder',
    method: 'post',
    data
  })
}
// 9-出库单详情
export function getOutboundOrderDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/warehouse/Warehouse/getOutboundOrderDetail',
    method: 'post',
    data
  })
}
// 9-出库单状态个数
export function getOutboundOrderCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/warehouse/Warehouse/getOutboundOrderCount',
    method: 'post',
    data
  })
}
// 8-获取验货单
export function getInspection(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getInspection',
    method: 'post',
    data
  })
}
// 16-获取所选采购单信息接口
export function getSelectedPurchases(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getSelectedPurchases',
    method: 'post',
    data
  })
}
// 14-获取配送方式
export function getLogisticsTransportTypeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsTransportTypeList',
    method: 'post',
    data
  })
}
// 15-获取物流公司列表
export function getLogisticsCompanyList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/Logistics/getLogisticsCompanyList',
    method: 'post',
    data
  })
}
// 15-创建物流单
export function addLogisticsOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/addLogisticsOrder',
    method: 'post',
    data
  })
}
// 获取物流单总数
export function getLogisticsListCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsListCount',
    method: 'post',
    data
  })
}
// 03-获取物流单详情
export function getLogisticsInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getLogisticsInfo',
    method: 'post',
    data
  })
}
// 03-获取物流单详情
export function getDeliverConsigneeImg(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getDeliverConsigneeImg',
    method: 'post',
    data
  })
}
// 4-验货接口
export function inspection(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/inspection',
    method: 'post',
    data
  })
}
// 3-获取司机专车不到户
export function getDriverNoHome(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/driver/Driver/getDriverNoHome',
    method: 'post',
    data
  })
}
// 3-获取司机专车到户
export function getDriverToHome(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/driver/Driver/getDriverToHome',
    method: 'post',
    data
  })
}
// 3-获取司机专车到户
export function getConsigneeResult(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_admin/logistics/logistics/getConsigneeResult',
    method: 'post',
    data
  })
}
